module.exports = __webpack_public_path__ + "static/media/photo-1-2.480f165a.jpg";